import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Moment } from 'moment/moment';

// Define the shape of the data you expect to receive
export interface DetailedViewDialogData {
    slot: any;
    visibleMetrics: any;
    showRawData?: boolean;
    venueId: string;
    venueName: string;
    dateStart: Moment;
    dateEnd: Moment;
}

@Component({
    selector: 'app-detailed-view-dialog',
    templateUrl: './detailed-view-dialog.html',
    styleUrls: ['./detailed-view-dialog.scss']
})
export class DetailedViewDialogComponent {

    constructor(
        public dialogRef: MatDialogRef<DetailedViewDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: DetailedViewDialogData,
    ) {

    }

    onClose(): void {
        this.dialogRef.close();
    }

}
